export const USERIDENTIFIERTYPES = [
    'IDENTIFIER_ID',
    'COKE_COOKIE'];


// WEBPACK FOOTER //
// ./src/app/services/constants/user-identifier-type-list.ts